<template>
  <c-box class="returns-wrapper" font-size="sm" :mx="{ base: '-md', md: 0 }">
    <!-- Product returns list -->
    <c-box class="row">
      <c-box
        class="col-12"
        display="flex"
        justify-content="space-between"
        align-items="center"
        mt="4xl"
        mb="xl"
      >
        <c-heading as="h1" size="xl" fontWeight="normal" data-cy="returns-title">
          {{ $t("productReturn.common.title") }}</c-heading
        >
        <c-box
          background="brand.grayLight"
          :width="{ base: '100%', lg: 'auto' }"
          :position="{ base: 'fixed', lg: 'static' }"
          p="sm"
          text-align="center"
          :z-index="{ base: 1, lg: 'auto' }"
          left="0"
          bottom="0"
        >
          <router-link to="/support/returns/new">
            <c-button
              m="0 auto"
              variation="solid"
              background="brand.beige"
              border-color="brand.beige"
              data-cy="create-new-return"
              tabindex="-1"
            >
              {{ $t("productReturnV2.common.createNew") }}
            </c-button>
          </router-link>
        </c-box>
      </c-box>
      <c-flex v-if="isLoading" mt="4xl" width="100%" justify-content="center">
        <Spinner />
      </c-flex>
      <c-box
        v-else-if="isError"
        class="col-lg-12"
        mt="2.5rem"
        font-style="italic"
        color="brand.red"
      >
        <c-heading as="h3" size="sm" font-weight="normal">
          {{ $t("productReturnV2.pastReturns.returnsError") }}
        </c-heading>
      </c-box>
      <c-box v-else-if="returnListing.length > 0" class="col-lg-12">
        <RMAReturnList :returnListing="returnListing" />
      </c-box>
      <c-box v-else class="col-lg-12" mt="2.5rem" font-style="italic">
        <c-heading as="h3" size="sm" font-weight="normal">
          {{ $t("productReturn.pastReturns.noReturns") }}
        </c-heading>
      </c-box>
    </c-box>
  </c-box>
</template>

<script lang="ts">
import Spinner from "@/components/Spinner.vue";
import RMAProcessSteps from "@/views/rma/RMAProcessSteps.vue";
import RMARequestEditor from "@/views/rma/RMARequestEditor.vue";
import RMAReturnList from "@/views/rma/RMAReturnList.vue";
import { CBox, CButton, CFlex, CHeading, CText } from "@chakra-ui/vue";
import { IResultEntity, orderProductReturnListItems, IRootState } from "@iloq/shared";
import { defineComponent } from "vue";
import { mapState } from "vuex";

export default defineComponent({
  name: "Returns",
  components: {
    RMARequestEditor,
    RMAProcessSteps,
    RMAReturnList,
    Spinner,
    CText,
    CBox,
    CFlex,
    CButton,
    CHeading,
  },
  computed: {
    ...mapState({
      returnListing: (state: unknown): any[] => {
        const returnList: IResultEntity[] = (state as IRootState).returns?.list || [];
        return orderProductReturnListItems(
          returnList,
          (state as IRootState).features?.productReturnDrafts,
        );
      },
      isLoading: (state: unknown) => (state as IRootState).returns?.loading,
      isError: (state: unknown) => (state as IRootState).returns?.error,
    }),
  },
});
</script>
